<div class="modal fade" id="adminModal" tabindex="-1" aria-labelledby="adminModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h1 class="modal-title fs-5 text-white" id="adminModalLabel">
                    <i class="bi bi-shield-lock-fill me-2 text-danger"></i>Admin Control Panel
                </h1>
                <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"
                    aria-label="Close"></button>
            </div>
            <div class="modal-body text-white">

                <!-- PASSWORD RESET SECTION -->
                <div class="mb-4 pb-4 border-bottom border-secondary">
                    <h5 class="fw-bold mb-3 text-warning">Reset User Password</h5>
                    <div class="form-floating mb-3">
                        <input type="text" class="form-control" placeholder="Username" [ngModel]="usernameForPassword()"
                            (ngModelChange)="usernameForPassword.set($event)" />
                        <label class="text-uppercase small">Username</label>
                    </div>
                    <div class="form-floating mb-3">
                        <input type="password" class="form-control" placeholder="New Password" [ngModel]="newPassword()"
                            (ngModelChange)="newPassword.set($event)" />
                        <label class="text-uppercase small">New Password</label>
                    </div>
                    <div class="form-floating mb-3">
                        <input type="password" class="form-control" placeholder="Confirm New Password"
                            [ngModel]="confirmNewPassword()" (ngModelChange)="confirmNewPassword.set($event)" />
                        <label class="text-uppercase small">Confirm New Password</label>
                    </div>
                    <button class="btn btn-outline-danger w-100 py-2 fw-bold" (click)="resetPassword()">
                        <i class="bi bi-key-fill me-1"></i> Reset Password
                    </button>
                </div>

                <!-- AWARD ICON SECTION -->
                <div>
                    <h5 class="fw-bold mb-3 text-warning">Award User Icon</h5>
                    <div class="form-floating mb-3">
                        <input type="text" class="form-control" placeholder="Username" [ngModel]="usernameForIcon()"
                            (ngModelChange)="usernameForIcon.set($event)" />
                        <label class="text-uppercase small">Username</label>
                    </div>

                    <div class="dropdown mb-3">
                        <button
                            class="btn btn-xl btn-outline-primary dropdown-toggle w-100 d-flex align-items-center justify-content-between text-start"
                            type="button" id="adminIconDropdownButton" data-bs-toggle="dropdown" aria-expanded="false">
                            <span class="d-flex align-items-center">
                                @if (selectedPortraitId(); as pId) {
                                @for (p of icons(); track p.id) {
                                @if (p.id === pId) {
                                <img [src]="'https://static.h5arena.com/images/icons/' + p.fileName"
                                    class="me-2 rounded-circle" width="32" height="32" alt="Selected Icon" />
                                }
                                }
                                }
                                {{ getIconName(selectedPortraitId()) }}
                            </span>
                        </button>
                        <ul class="dropdown-menu bg-dark text-white p-2 w-100" aria-labelledby="adminIconDropdownButton"
                            style="max-height: 250px; overflow-y: auto; z-index: 1065;">
                            @for(icon of icons(); track icon.id) {
                            <li class="text-white">
                                <a class="dropdown-item d-flex align-items-center py-2"
                                    (click)="selectedPortraitId.set(icon.id)" style="cursor: pointer;">
                                    <img [src]="'https://static.h5arena.com/images/icons/' + icon.fileName" width="32"
                                        height="32" class="me-2 rounded-circle" alt="Icon" />
                                    {{ icon.description || icon.fileName }}
                                </a>
                            </li>
                            }
                        </ul>
                    </div>

                    <div class="form-floating mb-3">
                        <input type="date" class="form-control" placeholder="Expiration Date"
                            [ngModel]="expirationDate()" (ngModelChange)="expirationDate.set($event)" />
                        <label class="text-uppercase small">Expiration Date</label>
                    </div>

                    <button class="btn btn-outline-danger w-100 py-2 fw-bold" (click)="awardIcon()">
                        <i class="bi bi-award-fill me-1"></i> Award Icon
                    </button>
                </div>

            </div>
            <div class="modal-footer p-0 border-0">
                <button type="button" class="btn btn-dark w-100 m-0 rounded-0 rounded-bottom fw-bold"
                    style="height: 4rem;" data-bs-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>